import { QUERY_KEYS } from 'api/query-keys';
import { sharedWorkTemplateService } from 'api/services';
import { workTemplateCreateDataResponse2WorkTemplateCreateDataModel } from 'ogp/services/mappers/mappers';
import { useQuery } from 'react-query';
import { useSiteDetection } from 'shared/hooks';
import { CACHE_TIME_LONG, STALE_TIME_LONG } from 'shared/react-query/query-defaults';

export const useGetWorkTemplateCreateData = () => {
  const { site } = useSiteDetection();
  const queryFn = async () => await sharedWorkTemplateService.getWorkTemplateCreateData(site);

  return useQuery(QUERY_KEYS.getWorkTemplateCreateData(), {
    queryFn,
    cacheTime: CACHE_TIME_LONG,
    staleTime: STALE_TIME_LONG,
    select: workTemplateCreateDataResponse2WorkTemplateCreateDataModel,
  });
};
